/*
 * @Copyright: Copyright (c) 2021 Yihua, All right is reserverd
 * @name: router
 * @Description: 路由
 * @FilePath: /hugou-h5/src/router/index.js
 * @Version: 0.1.0
 * @Autor: hselenat
 * @Date: 2021-04-27 16:07:25
 * @LastEditors: hselenat
 * @LastEditTime: 2021-04-27 17:02:11
 * @example: 调用示例
 */
import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/pages/HomePage'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: HomePage
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js